export default __webpack_public_path__ + "static/media/post-placeholder.629d4dfa.jpg";